import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { CounselingService } from 'src/app/shared/services/API/risk-classification/counseling.service';

@Component({
  selector: 'app-counseling-delete-modal',
  templateUrl: './counseling-delete-modal.component.html',
  styleUrls: ['./counseling-delete-modal.component.css']
})
export class CounselingDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<CounselingDeleteModalComponent>,
    private counselingService: CounselingService,
    private alertService: AlertService,
  ) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteCounseling: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.counselingService.deleteCounseling(this.data.idCounseling).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Aconselhamento excluido com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteCounseling: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteCounseling: false}); 
  }
}